<template>
  <v-container fluid class="pa-0">
    <v-card color="blue-grey lighten-5" class="elevation-11">
      <v-img
        class="mb-1"
        :src="imgLoc"
        height="200px">
      </v-img>
      <v-card-text class="card">
        <h3>Hi {{user.fname}}...!</h3>

        <div v-if="user.userId !== $store.state.adminId">
          <p v-if="nextLesson">Your next scheduled lesson is {{nextLesson.date | formatDateFull}} at {{formatTime(nextLesson.lessonTime)}}.</p>
          <p v-else><a href="#" @click="$router.push('/lessons')">Schedule your next lesson </a></p>
        </div>
        <hr/>
        <div v-for="(greeting, index ) in greetings" :key="greeting.id">
          <span v-if="index + 1 !== greetings.length" class="greetings">
            <p>{{greeting.description}}</p>
          </span>
          <span v-else>
            <hr/>
            <p>{{greeting.description}}</p>
          </span>
        </div>

        <div class="books">
          <a :href=booksURL target="_blank"><img class="mt-2 cs" src="../assets/The Contemporary Singer.jpg" alt="Nancy's bookshelf"></a>
          <a :href=booksURL target="_blank"><img class="mt-2 ml-2 cs" src="../assets/Sing Anything.jpg" alt="Nancy's bookshelf"></a>
          <a :href=booksURL target="_blank"><img class="mt-2 ml-2 cs" src="../assets/Effortless Mastery.jpg" alt="Nancy's bookshelf"></a>
          <a :href=booksURL target="_blank"><img class="mt-2 ml-2 cs" src="../assets/Singing and the Actor.jpg" alt="Nancy's bookshelf"></a>
          <a :href=booksURL target="_blank"><img class="mt-2 ml-2 cs" src="../assets/Solutions for Singers.jpg" alt="Nancy's bookshelf"></a>
        </div>

      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { addDays, addMonths } from "date-fns"
import { sortByDate } from '../mixins/utilities.js'
import isWithinRange from "date-fns/is_within_range"
export default {
  created() {
    if (this.$store.state.user === undefined) {
      this.$router.push("/signin")
    }
  },
  data() {
    return {
      imgLoc: "https://thumbs.dreamstime.com/z/musical-notes-13094940.jpg",
      today: new Date(),
      booksURL:
        "https://firebasestorage.googleapis.com/v0/b/creative-cards-app-171c7.appspot.com/o/downloads%2Fhandouts%2FNancy's%20Bookshelf.pdf?alt=media&token=2a0f7a27-4b46-49f4-984f-153587420b10"
    }
  },
  computed: {
    user() {
      return this.$store.getters.getUser
    },
    greetings() {
      const greetings = this.$store.getters.getGreetings

      let arrFiltered = greetings.filter(
        el => el.viewableBy === "all" || el.viewableBy === this.user.userId && new Date(greeting.dateStart) < this.today && new Date(greeting.dateEnd) > this.today
      )
      return arrFiltered
    },
    nextLesson() {
      let twoMonthsFromNow = addMonths(new Date(), 2)
      let oneWeekAgo = addDays(new Date(), -1)

      if (this.$store.getters.getStudentLessons) {
        let arrLessons = this.$store.getters.getStudentLessons.filter(el => {
          return isWithinRange(el.date, oneWeekAgo, twoMonthsFromNow)
        })
        return arrLessons.sort((a,b)=> new Date(a.date) - new Date(b.date))[0]
      }
    }
  },
  methods: {
    formatTime(strTime) {
      var idx = strTime.indexOf('-')
      return strTime.substring(0, idx)
    }
  }
}
</script>

<style scoped>

h3 {
  margin-bottom: 15px;
}

p {
  margin-bottom: 8px;
}

a {
  color: black;
}

.card {
  padding: 25px;
}

hr {
  border-top: 2px double lightslategray;
  margin-bottom: 15px;
  margin-top: 5px;
  width: 90%;
}

.books {
  display: inline-flex;
}

img {
  max-width:100%;
  height:auto;
  }

.cs {
  height: 180px;
}
</style>